import { Grid, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import {
  consumableSupply_pack,
  consumableSupply_rolls,
} from '../../../../../../../data/forms/nrc/consumableSupplyDropdownOptions.js';

export default function IndianaSupplySelectForm({ supplySelections, setForm }) {
  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prevForm => ({
      ...prevForm,
      supplySelections: {
        ...prevForm.supplySelections,
        [name]: value,
      },
    }));
  };

  return (
    <>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash 5 Playslip'}</InputLabel>
          <Select
            value={supplySelections.cash5}
            label={'Cash 5 Playslip'}
            onChange={handleChange}
            name='cash5'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Cash Pop Playslip'}</InputLabel>
          <Select
            value={supplySelections.cashPop}
            label={'Cash Pop Playslip'}
            onChange={handleChange}
            name='cashPop'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 3 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily3}
            label={'Daily 3 Playslip'}
            onChange={handleChange}
            name='daily3'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Daily 4 Playslip'}</InputLabel>
          <Select
            value={supplySelections.daily4}
            label={'Daily 4 Playslip'}
            onChange={handleChange}
            name='daily4'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Lotto Playslip'}</InputLabel>
          <Select
            value={supplySelections.lotto}
            label={'Lotto Playslip'}
            onChange={handleChange}
            name='lotto'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid size={6}>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Mega Millions Playslip'}</InputLabel>
          <Select
            value={supplySelections.megaMillions}
            label={'Mega Millions Playslip'}
            onChange={handleChange}
            name='megaMillions'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerball}
            label={'Powerball Playslip'}
            onChange={handleChange}
            name='powerball'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Powerball X\'s & O\'s Playslip'}</InputLabel>
          <Select
            value={supplySelections.powerballXsOs}
            label={'Powerball X\'s & O\'s Playslip'}
            onChange={handleChange}
            name='powerballXsOs'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Quick Draw Playslip'}</InputLabel>
          <Select
            value={supplySelections.quickDraw}
            label={'Quick Draw Playslip'}
            onChange={handleChange}
            name='quickDraw'
          >
            {consumableSupply_pack.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl
          sx={{
            backgroundColor: '#ffffff',
            marginBottom: '15px',
            width: '100%',
          }}
        >
          <InputLabel>{'Ticket Stock (Printer Paper)'}</InputLabel>
          <Select
            value={supplySelections.ticketStock}
            label={'Ticket Stock (Printer Paper)'}
            onChange={handleChange}
            name='ticketStock'
          >
            {consumableSupply_rolls.map(jid => (
              <MenuItem value={jid}>{jid}</MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </>
  );
}
